import { Sports, SportsDisplayNames } from '../../enums';
import * as React from 'react';

export interface Props {
  name: string;
  value?: string;
  onChange?: (any) => void;
  className?: string;
  id?: string;
  disabled?: boolean;
  inputRef: any;
}

export const getSportName = (value) => {
  const sport = sportOptions.find((option) => option.value == value);

  return sport?.text;
};

export const sportOptions = [
  { value: '', text: 'Select a sport' },
  ...Object.keys(Sports)
    .filter((key) => isNaN(Number(key))) // Filter out numeric values
    .map((key) => ({
      text: SportsDisplayNames[key as keyof typeof SportsDisplayNames].toString(),
      value: Sports[key as keyof typeof Sports].toString(),
    })),
];

export const sortSportList = () => {
  sportOptions.sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
  return sportOptions;
};

export const sortedSportOptions = () => {
  sortSportList();
  sportOptions.forEach((item, i) => {
    if (item.value === '') {
      sportOptions.splice(i, 1);
      sportOptions.unshift(item);
    }
  });
  return sportOptions;
};

const SportSelect = (props: Props) => (
  <div className="SelectBox">
    <select
      className={'SelectBox-options ' + (props.className || '')}
      onChange={props.onChange}
      onBlur={props.onChange}
      value={props.value || undefined}
      id={props.id}
      ref={props.inputRef}
      name={props.name}
      disabled={props.disabled}
    >
      {sortedSportOptions().map((o) => (
        <option key={o.value} value={o.value}>
          {o.text}
        </option>
      ))}
    </select>
  </div>
);

export default SportSelect;
